module.exports = __webpack_public_path__ + "static/media/espiga_trotilla.f0435947.png";